/* eslint-disable @typescript-eslint/default-param-last */
import { createSlice } from '@reduxjs/toolkit';
import REDUX_SLICE_NAMES from 'consts/redux-slice-names';
import { useAppDispatch, useAppSelector } from '../hooks';
import { IUserAction, UserReducerType } from '../reducer-types';
import { RootState } from '../store';

export const initialState: UserReducerType = {
  displayName: null,
  mail: null,
  id: null,
  checkUserLogout: false,
  checkUserLogin: false,
};

const userSlice = createSlice({
  name: REDUX_SLICE_NAMES.USER,
  initialState,
  reducers: {
    setUserState: (state: UserReducerType = initialState, action: IUserAction) => {
      Object.keys(action.payload).forEach((field) => {
        state[field as keyof UserReducerType] = action.payload[field as keyof UserReducerType] as never;
      });
    }
  }
});

const { setUserState } = userSlice.actions;

export const useGetUserState = () => useAppSelector((state: RootState) => state[userSlice.name]) as UserReducerType;

export const useSetUserState = () => {
  const dispatch = useAppDispatch();
  return {
    setUserFields: (fields: Partial<UserReducerType>) => {
      dispatch(setUserState(fields));
    }
  };
};
export default userSlice;
